export default __webpack_public_path__ + "static/table_repeating_pattern_long-de640f60d888bcf9ee108a743f3015ee.jpg";